import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-brand-obsidian text-brand-alabaster mt-20 font-sans-clean" data-testid="marketing-footer">
      <div className="max-w-6xl mx-auto px-6 lg:px-10 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-14 md:gap-10 items-start">
          {/* Brand */}
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img
                src="https://customer-assets.emergentagent.com/job_student-pathfinder-21/artifacts/ujq9wzpi_True%20Global%20Logo.png"
                alt="True Global Education"
                className="h-12 w-auto"
              />
              <div>
                <div className="font-serif-editorial text-2xl leading-none">True Global</div>
                <div className="text-[10px] uppercase tracking-[0.22em] text-brand-coral font-bold mt-1.5">Education</div>
              </div>
            </div>
            <p className="mt-8 text-sm text-white/60 leading-relaxed max-w-sm">
              Education is not the destination. It&apos;s the pathway. We help Canadians choose it with clarity.
            </p>
          </div>

          {/* Contact block */}
          <div className="md:col-span-4">
            <div className="text-[10px] uppercase tracking-[0.22em] text-brand-coral font-bold mb-5">Visit us</div>
            <div className="flex items-start gap-3 text-sm text-white/80">
              <MapPin size={15} className="text-brand-coral mt-1 flex-shrink-0" />
              <div className="leading-relaxed">
                <div className="font-semibold text-white">Payal Business Centre</div>
                <div className="text-white/70">8166 128 St #109, Surrey, BC V3W 4G1</div>
              </div>
            </div>
            <div className="mt-5 flex items-center gap-3 text-sm">
              <Phone size={15} className="text-brand-coral flex-shrink-0" />
              <a href="tel:+16048141515" className="text-white/80 hover:text-brand-coral transition-colors">
                (604) 814-1515
              </a>
            </div>
            <div className="mt-3 flex items-center gap-3 text-sm">
              <Mail size={15} className="text-brand-coral flex-shrink-0" />
              <a href="mailto:info@trueglobaleducation.com" className="text-white/80 hover:text-brand-coral transition-colors break-all">
                info@trueglobaleducation.com
              </a>
            </div>
          </div>

          {/* Hours */}
          <div className="md:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.22em] text-brand-coral font-bold mb-5">Office hours</div>
            <div className="flex items-start gap-3">
              <Clock size={15} className="text-brand-coral mt-1 flex-shrink-0" />
              <div className="text-sm text-white/75 space-y-1.5 leading-relaxed">
                <div className="flex justify-between gap-4">
                  <span>Mon &ndash; Fri</span>
                  <span className="text-white/90">8:00 &ndash; 5:00</span>
                </div>
                <div className="flex justify-between gap-4">
                  <span>Saturday</span>
                  <span className="text-white/90">9:00 &ndash; 4:00</span>
                </div>
                <div className="flex justify-between gap-4">
                  <span>Sunday</span>
                  <span className="text-white/50">Closed</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="text-xs text-white/40">
            © {new Date().getFullYear()} True Global Education. All rights reserved.
          </div>
          <div className="flex items-center gap-6 text-xs text-white/40">
            <Link to="/privacy" className="hover:text-brand-coral transition-colors">Privacy</Link>
            <Link to="/terms" className="hover:text-brand-coral transition-colors">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
